export class ProductType {
  id: number
  name: string

  public static from(obj: any): ProductType {
    return Object.assign(new ProductType(), obj)
  }
}
